module.exports = __webpack_public_path__ + "img/exp.bc17e359.png";